import React, { Component } from 'react'
import SupportTemplateListUI from './SupportTemplateListUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class SupportTemplateListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updateMode: false,
      selectedTemplate: null,
      onMoveUpMode: false,
    }
  }

  render() {
    console.log(this.props.templateList)
    return (
      <SupportTemplateListUI
        context={this.props.context}
        rootTemplate={this.props.rootTemplate}
        templateList={this.props.templateList}
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onCancelUpdateClick={() => { this.setState({ updateMode: false }) }}
        selectedTemplate={this.state.selectedTemplate}
        onRefreshClick={this.props.onRefreshClick}
        onMoveUpMode={this.state.onMoveUpMode}
        onMoveUpSubmit={this.onMoveUpSubmit}

      />
    )
  }

  onUpdateClick = (event) => {
    let templateId = event.currentTarget.getAttribute('data-template-id')
    console.log(templateId);
    let selectedTemplate = this.getSelectedTemplate(this.props.rootTemplate, templateId)
    this.setState({ updateMode: true, selectedTemplate: selectedTemplate })
  }

  onMoveUpSubmit = (event) => {
    let templateId = event.currentTarget.getAttribute('data-template-id');
    RestApiUtils.put(
      this.props.context,
      `/api/su/support/templates/${templateId}/swipeUp`,
      this.onMoveUpSubmitCallback
    );

    this.setState({ onMoveUpMode: true });
  }

  onMoveUpSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      onMoveUpMode: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
      }, 1000)
    }

    if (response.errorList.length) {
      setTimeout(() => {
        this.setState({ errorList: [] })
      }, 5000)
    }
  }

  getSelectedTemplate(node, templateId) {
    console.log(node.supportTemplateId)
    if (node == null)
      return null
    if (node.supportTemplateId === templateId) {
      console.log('found')
      return node
    }
    for (let child of node.supportTemplateList) {
      let template = this.getSelectedTemplate(child, templateId)
      if (template != null)
        return template
    }
    return null
  }

}

export default SupportTemplateListSF
